import script from "./FeatureTourOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureTourOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureTourOverlay.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__